import { Close as CloseIcon, Download } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Modal,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { getFileIcon, getFileName } from './DecoratedChip';

const downloadFile = (url: string): void => {
  window.open(url, '_blank');
};

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh',
  overflow: 'auto',
};

export interface FileModalProps {
  urls: string[];
  modalOpen: boolean;
  onClose: () => void;
  onChipClick: (url: string) => void;
}

function FileModal({
  urls,
  onClose,
  modalOpen,
  onChipClick,
}: FileModalProps): React.ReactNode {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredUrls = urls.filter((url) =>
    getFileName(url).toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <Modal
      aria-labelledby="files-modal-title"
      onClose={onClose}
      open={modalOpen}
    >
      <Paper sx={modalStyle}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          mb={2}
        >
          <Typography component="h2" id="files-modal-title" mb={2} variant="h6">
            All Files
          </Typography>
          <Button
            color="primary"
            onClick={onClose}
            sx={{ ml: 'auto', borderRadius: '500px' }}
            variant="text"
          >
            <CloseIcon />
          </Button>
        </Box>
        <TextField
          fullWidth
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
          placeholder="Search files..."
          sx={{ mb: 2 }}
          value={searchQuery}
          variant="outlined"
        />
        <List>
          {filteredUrls.map((url) => (
            <ListItem
              key={url}
              secondaryAction={
                <IconButton
                  aria-label="download"
                  edge="end"
                  onClick={() => {
                    downloadFile(url);
                  }}
                >
                  <Download />
                </IconButton>
              }
            >
              <ListItemIcon>{getFileIcon(url)}</ListItemIcon>
              {/* <ListItemText primary={getFileName(url)} /> */}
              <Button
                onClick={() => {
                  onChipClick(url);
                }}
                variant="text"
                sx={{ textTransform: 'none' }}
                color="inherit"
              >
                {getFileName(url)}
              </Button>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Modal>
  );
}

export default FileModal;
